export default new (class SidebarMenu {
    constructor() {
        this.currentDropdown = null

        this.sMenuClass = "_sidebar"
        this.sButtonMenuClass = "_sidebar-btn-open"
        this.sContentMenuClass = "_sidebar-content"

        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        //side click
        if(document.querySelector(`.${this.sButtonMenuClass}`)) {
            document.querySelector(`.${this.sButtonMenuClass}`).addEventListener('click', (obEvent) => {
                this.sidebarMenuToggle(obEvent)
            })
        }

        //закрытие при нажатии на пустоту
        document.addEventListener('click', (e) => {
            if (this.currentDropdown && e.target !== this.currentDropdown && !e.target.closest(`.${this.sMenuClass}`)) {
                this.sidebarMenuToggle();
            }
        });
    }

    sidebarMenuToggle(obEvent = null) {
        if(obEvent) {
            obEvent.preventDefault()
        }

        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sContentMenuClass}`).classList.toggle("opacity-100")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sContentMenuClass}`).classList.toggle("visible")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sContentMenuClass}`).classList.toggle("invisible")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sContentMenuClass}`).classList.toggle("opacity-0")

        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sButtonMenuClass}`).classList.toggle("after:scale-[-1]")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sButtonMenuClass}`).classList.toggle("after:scale-1")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sButtonMenuClass}`).classList.toggle("after:top-[3px]")
        document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sButtonMenuClass}`).classList.toggle("after:top-[-3px]")

        if (document.querySelector(`.${this.sMenuClass}`).querySelector(`.${this.sContentMenuClass}`).classList.contains("opacity-100")) {
            this.currentDropdown = obEvent.target.closest(`.${this.sMenuClass}`);
        } else {
            this.currentDropdown = null;
        }
    }

})()
